import axios from "axios";
import { getTokenAccessor } from "@/lib/auth";

const SARAH_BASE: string = import.meta.env.VITE_SARAH_SERVICE_BASE_URL || "";

const sarahApi = axios.create({
  baseURL: `${SARAH_BASE}/sarah/v1`,
  headers: { "Content-Type": "application/json" },
});

sarahApi.interceptors.request.use((config) => {
  const token = getTokenAccessor();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

interface SubscriberIdResponse {
  distinctId: string;
  subscriberId: string;
}

export async function fetchSubscriberId(
  email: string
): Promise<SubscriberIdResponse> {
  const response = await sarahApi.get<SubscriberIdResponse>(
    "/notifications/suprsend/subscriber-id",
    {
      params: { email },
    }
  );
  return response.data;
}
